// extracted by mini-css-extract-plugin
module.exports = {"section":"CefrTool_section__2M90A","versionsContainer":"CefrTool_versionsContainer__2LT6h","chip":"CefrTool_chip__3awqO","inputWrapper":"CefrTool_inputWrapper__2N97u"};